import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AppInfo from "./component";
import { fetchDownloadLink } from "./actions";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchDownloadLinkConnect: fetchDownloadLink
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AppInfo);
